// @ts-nocheck
import { MOCK } from "@/state/app-store";
import { UI } from "@/components/ui";
import { Icon } from "@/components/icons";
import { api } from "@/api/index";

const { $, $$, fmtNum, fmtMoney, fmtPercent, toast, confirmModal, hasPerm, statusBadge, trendArrow, statCard, channelChip, capabilityBadge, pageHeader, emptyState, primaryBtn, ghostBtn, stepIndicator, BUSINESS_COLORS, chartTooltip, chartXAxis, chartYAxis, chartLineSeries, chartBarSeries } = UI;

declare const echarts: any;
declare const Pages: Record<string, any>;
declare const PageHooks: { mounted?: ((path: string) => void) | null };
declare function navigate(path: string): void;
declare function getCurrentPath(): string;
declare function getCurrentPathWithQuery(): string;
declare function renderRoute(): void;

if (typeof window !== "undefined") {
  (window as any).Pages = (window as any).Pages || {};
}

const Pages = (window as any).Pages;

// ============================================================
// 管理员功能 · 游戏全局管理
// 承载平台级 / 高风险 / 全局游戏操作，避免散落在研发工具中
// ============================================================

window.Pages = window.Pages || {};

Pages.adminGameGovernance = function () {
  if (!UI.hasPerm("admin")) {
    return UI.emptyState({ icon: "🔒", title: "权限不足", desc: "仅 SDK 管理员可访问游戏全局管理" });
  }

  return `
    ${UI.pageHeader({
      title: "游戏管理",
      desc: "SDK 管理员专用：集中处理跨游戏状态、接入完整度、高风险和敏感凭证治理，不承载日常游戏接入维护",
      actions: `<button onclick="navigate('/admin/security/users')" class="px-3 py-1.5 text-sm border border-ink-200 rounded-md hover:bg-ink-50">查看用户与角色</button>`,
    })}

    <div class="card overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100 flex items-center justify-between">
        <div class="flex items-center gap-2.5">
          <h3 class="text-sm font-semibold text-ink-900">全部游戏</h3>
          <span class="badge bg-brand-50 text-brand-700">共 <span class="num font-semibold">${MOCK.GAMES.length}</span> 款</span>
        </div>
        <input type="text" placeholder="搜索游戏名称 / GameID" class="w-64 text-xs border border-ink-200 rounded-md px-3 py-1.5" />
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-3 font-semibold">游戏</th>
            <th class="text-left px-4 py-3 font-semibold">Game ID</th>
            <th class="text-left px-4 py-3 font-semibold">Game Secret</th>
            <th class="text-center px-4 py-3 font-semibold">包体</th>
            <th class="text-left px-4 py-3 font-semibold">状态</th>
            <th class="text-right px-4 py-3 font-semibold">管理员操作</th>
          </tr>
        </thead>
        <tbody>
          ${MOCK.GAMES.map(g => {
            const packageCount = MOCK.PACKAGES.filter(p => p.game_id === g.id).length;
            const secretPreview = `gs_live_${g.id.replace(/[^a-z0-9]/gi, "").padEnd(16, "0")}********`;
            return `
              <tr class="border-t border-ink-100 row-hover">
                <td class="px-4 py-3">
                  <div class="flex items-center gap-2.5">
                    <span class="text-lg">${g.icon}</span>
                    <div>
                      <div class="font-semibold text-ink-900">${g.name}</div>
                      <div class="text-[11px] text-ink-500">${g.category}</div>
                    </div>
                  </div>
                </td>
                <td class="px-4 py-3"><code class="font-mono text-xs px-2 py-0.5 bg-brand-50 text-brand-700 rounded">${g.id}</code></td>
                <td class="px-4 py-3"><code class="font-mono text-xs px-2 py-0.5 bg-warn-50 text-warn-700 rounded">${secretPreview}</code></td>
                <td class="px-4 py-3 text-center num">${packageCount}</td>
                <td class="px-4 py-3">${adminGameStatus(g.status)}</td>
                <td class="px-4 py-3 text-right">
                  <button onclick="adminResetGameSecret('${g.id}', '${g.name}')" class="text-xs text-amber-700 hover:underline mr-2">重置 Secret</button>
                  <button onclick="adminTransferOwner('${g.id}', '${g.name}')" class="text-xs text-brand-700 hover:underline mr-2">转移</button>
                  <button onclick="adminDeleteGame('${g.id}', '${g.name}')" class="text-xs text-danger-600 hover:underline">永久删除</button>
                </td>
              </tr>
            `;
          }).join("")}
        </tbody>
      </table>
    </div>

    <div class="card mt-4 overflow-hidden">
      <div class="px-5 py-4 border-b border-ink-100">
        <h3 class="text-sm font-semibold text-ink-900">高风险操作审计</h3>
        <p class="text-xs text-ink-500 mt-0.5">记录最近的管理员级游戏治理操作</p>
      </div>
      <table class="w-full text-sm">
        <thead class="bg-ink-50 text-xs text-ink-500">
          <tr>
            <th class="text-left px-4 py-2.5 font-medium">时间</th>
            <th class="text-left px-4 py-2.5 font-medium">操作者</th>
            <th class="text-left px-4 py-2.5 font-medium">操作</th>
            <th class="text-left px-4 py-2.5 font-medium">目标</th>
            <th class="text-left px-4 py-2.5 font-medium">结果</th>
          </tr>
        </thead>
        <tbody>
          ${[
            { time: "2026-05-19 10:25:11", user: "李管理", action: "重置 Game Secret", target: "TankBlitz", result: "成功" },
            { time: "2026-05-18 19:40:22", user: "李管理", action: "禁用服务端 OpenAPI Key", target: "测试 Demo", result: "成功" },
            { time: "2026-05-17 16:02:03", user: "李管理", action: "转移所有权", target: "Match Hero", result: "成功" },
          ].map(l => `
            <tr class="border-t border-ink-100">
              <td class="px-4 py-3 text-xs font-mono text-ink-500">${l.time}</td>
              <td class="px-4 py-3">${l.user}</td>
              <td class="px-4 py-3">${l.action}</td>
              <td class="px-4 py-3">${l.target}</td>
              <td class="px-4 py-3"><span class="badge bg-ok-50 text-ok-700">${l.result}</span></td>
            </tr>
          `).join("")}
        </tbody>
      </table>
    </div>
  `;
};

function adminGameStatus(status) {
  const map = {
    active: "稳定运营",
    stable: "稳定运营",
    launch: "发行初期",
    draft: "筹备中",
    paused: "暂停",
    archived: "归档",
  };
  return `<span class="badge bg-ink-100 text-ink-700">${map[status] || status}</span>`;
}

window.adminResetGameSecret = function (gameId, gameName) {
  const newSecret = `gs_live_${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}${Math.random().toString(36).slice(2)}`.replace(/[^a-z0-9_]/gi, "").slice(0, 48);
  UI.confirmModal({
    title: "重置 Game Secret",
    content: `确定要重置 <strong>${gameName}</strong> 的 Game Secret 吗？重置后该游戏下所有包体服务端部署都需要同步更新。<br/><br/><code class="block p-2 bg-ink-50 rounded font-mono text-xs break-all">${newSecret}</code>`,
    confirmText: "确认重置",
    onConfirm: () => { copyText(newSecret, "新 Game Secret "); UI.toast("Game Secret 已重置并复制", "success"); },
  });
};

window.adminTransferOwner = function (gameId, gameName) {
  UI.confirmModal({
    title: "转移游戏所有权",
    content: `确定要发起 <strong>${gameName}</strong> 的所有权转移流程吗？系统将进入审批流程。`,
    confirmText: "发起转移",
    onConfirm: () => UI.toast("已发起所有权转移流程", "info"),
  });
};

window.adminDeleteGame = function (gameId, gameName) {
  const packageCount = MOCK.PACKAGES.filter(p => p.game_id === gameId).length;
  UI.confirmModal({
    title: "永久删除游戏",
    content: `确定要永久删除 <strong>${gameName}</strong> 吗？将删除 ${packageCount} 个包体、所有分享配置、历史漏斗和用户路径数据。<br/><br/><span class="text-danger-700 font-semibold">此操作不可恢复。</span>`,
    confirmText: "确认删除",
    onConfirm: () => UI.toast("游戏已永久删除", "error"),
  });
};

// __window_exports__
// Expose helpers for cross-page / inline onclick compatibility
;(window as any).adminGameStatus = adminGameStatus;
